import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { Box, BoxProps, lessThan, Text, TextProps } from 'localmed-core';
import { ComponentProps } from 'react';
import {
  display,
  fontSize,
  fontWeight,
  justifyContent,
  margin,
  minWidth,
  textAlign,
} from 'styled-system';
import { Theme } from '../../../../diTheme';
import { DiButton } from '../../../../shared/components/DiComponents';

export const Wrapper = styled(Box)<BoxProps, Theme>(
  ({ theme }) => css`
    max-width: ${theme.breakpoints.lg};
    margin: 0 auto;
    width: 100%;
    padding-bottom: ${theme.space.lg};
    padding-top: ${theme.space.lg};
    flex: 1 0 0;
  `,
  lessThan(
    'lg',
    ({ theme }) => css`
      padding-left: ${theme.space.md};
      padding-right: ${theme.space.md};
    `
  ),
  justifyContent
);

export const ContentWrapper = styled(Box)<BoxProps, Theme>(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    align-items: center;
    justify-items: center;
    flex-direction: column;
    margin-bottom: ${theme.space.lg};
  `
);

export const BackButton = styled(DiButton)<ComponentProps<typeof DiButton>, Theme>(
  ({ theme }) => css`
    border: 1px solid ${theme.colors.lightGray};
  `
);

type RadioGroupItemWrapperProps = BoxProps & {
  selected?: boolean;
};

export const RadioGroupItemWrapper = styled(Box)<RadioGroupItemWrapperProps, Theme>(
  ({ theme, selected }) => css`
    border-radius: ${theme.radii.lg};
    border: ${selected ? `1px solid ${theme.colors.blue}` : `1px solid ${theme.colors.lightGray}`};
    padding: ${theme.space.md};
    background-color: ${selected ? theme.colors.blue : 'transparent'};
    color: ${selected ? theme.colors.white : theme.colors.blue};
    text-align: center;
    transition: background-color 200ms ease-in-out, border-color 200ms ease-in-out,
      color 200ms ease-in-out;
    margin: ${theme.space.xs};
  `,
  minWidth,
  display
);

export const CheckBox = styled('input')<ComponentProps<'input'>, Theme>(
  ({ theme }) => css`
    margin-right: ${theme.space.sm};
  `
);

type LabelProps = ComponentProps<'label'> & {
  required?: boolean;
};

export const Label: any = styled('label')<LabelProps, Theme>(
  ({ theme, required }) => css`
    font-weight: 700;
    font-size: ${theme.fontSizes.xs};
    margin-left: ${required ? theme.space.sm : 'auto'};
    &:before {
      content: '*';
      display: ${required ? 'block' : 'none'};
      position: absolute;
      margin-top: ${theme.space.xxs};
      color: ${theme.colors.red};
    }
  `,
  fontWeight,
  fontSize,
  margin,
  textAlign
);

export const CaptionText = styled(Text)<TextProps, Theme>(
  ({ theme }) => css`
    margin-top: ${theme.space.md};
    margin-bottom: ${theme.space.xs} !important;
    font-size: ${theme.fontSizes.sm};
  `
);

export const DiRule = styled('hr')<ComponentProps<'hr'>, Theme>(
  ({ theme }) => css`
    border-color: ${theme.colors.gray};
  `
);

export const InputErrorField = styled('div')<ComponentProps<'div'>, Theme>(
  ({ theme }) => css`
    color: ${theme.colors.errorText};
    font-size: ${theme.fontSizes.sm};
    text-align: right;
  `,
  lessThan(
    'md',
    ({ theme }) => css`
      font-size: ${theme.fontSizes.xs};
    `
  )
);
